<template>
    <div>
        <base-crud
                crudName="Não Conformidades"
                newText="Nova Não Conformidade"
                :table="nonconformityTable"
                :columns="columns"
                :options="options"
                :endPoint='endPoint'
                :enableAdd="false"
                :enableEdit="false"
                :enableDelete="true"
                :enableView="true"
        >
        </base-crud>
    </div>
</template>

<script>
    import BaseCrud from '../Base/BaseCrud'

    export default {
        data: function () {
            return {
                nonconformityTable: 'nonconformityTable',
                nonconformities: [],
                pages: [],
                url: '',
                columns: ['id', 'branch.name', 'team.name', 'user.name', 'status', 'created_at', 'actions'],
                tableData: ['id', 'branch.name', 'team.name', 'user.name', 'status', 'created_at'],
                options: {
                    filterable: ["id", "branch.name", "team.name", "user.name", "status", "created_at"],
                    filterByColumn: true,                   
                    sortable: ['id', 'branch.name', 'team.name', 'user.name', 'status', 'created_at'],
                    pagination: {chunk: 10, dropdown: false, nav: 'scroll'},
                    perPage: 10,
                    perPageValues: [10,25,50,100],
                    headings: {
                        'id': 'ID',
                        'branch.name': 'Unidade',
                        'team.name': 'Área',
                        'user.name': 'Usuário',
                        'status': 'Status',
                        'created_at': 'Data de Criação',
                        'actions': 'Ações'
                    },
                    templates: {
                        'created_at': function(h, row, vm) {
                            return new Date(row.created_at).toLocaleDateString();
                        },
                        'status': function(h, row, vm) {
                            const status = row.status || 'Pendente';
                            const statusClass = status === 'Fechado' ? 'text-success' : 'text-warning';
                            return h('span', { class: statusClass }, status);
                        }
                    },
                    requestFunction: function(data) {
                      let requestData = {};

                       let query = this.$parent.$parent.query(data.query);
                       requestData.params = data;
                       requestData.params.query = "";
                       requestData.params.with = ['user', 'branch', 'team', 'checklist', 'checklistItem', 'photos'];

                      return this.$http
                          .get(this.url + '?' + query, requestData)
                          .catch(
                              function(e) {
                                  this.dispatch("error", e);
                              }.bind(this)
                          );
                    },
                },
                endPoint: 'nonconformities/'
            }
        },
        methods: {
            query: function (query) {
                let columns = {
                    id: 'id',
                    'branch.name': 'branch.name',
                    'team.name': 'team.name',
                    'user.name': 'user.name',
                    'status': 'status',
                    'created_at': 'created_at',
                };
                let filters = "";
                $.each(query, function (index, value) {
                    filters += columns[index] + "=" + value + "&";
                });
        
                return filters;
            },
            formatDate(date) {
                if (!date) return '';
                const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' };
                return new Date(date).toLocaleDateString('pt-BR', options);
            }
        },
        components: {
            BaseCrud
        }
    }
</script>

<style scoped>
    .VuePagination {
        text-align: center;
    }
</style> 


// WEBPACK FOOTER //
// src/components/Nonconformity/Crud.vue